import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { enableProdMode } from '@angular/core';
import * as Sentry from '@sentry/angular';

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: 'https://b740587d0a413c7e6bf03ddbc2daa4ef@sentry.h100b.com/8',
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: environment.production ? 0.1 : 1.0,
  tracePropagationTargets: ['localhost', /^https:\/\/(api|www|stage|dev)\.[a-z0-9-]*letsgocasino\d*\.com/],
  environment: environment.production ? 'prod' : 'stage',
  sendDefaultPii: true,
});

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
